/* eslint-disable react/prop-types */
// localization

import { useTranslation } from 'react-i18next';

import { useState } from 'react';
// @mui
import { useNavigate } from 'react-router-dom';
import {
  Table,
  TableRow,
  TableBody,
  Button,
  TableCell,
  Typography,
  TableContainer,
  Pagination,
  Box,
} from '@mui/material';

// icons imports

import { ReactComponent as EditIcon } from '../../../theme/images/editTableIcon.svg';

// components
import Scrollbar from '../../../components/scrollbar/Scrollbar';

// sections
import ClientReqHead from '../../../components/clientHeadTable/ClientHeadTable';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'NAME_EN', label: 'Unit Name', alignRight: false },
  { id: 'creation_date', label: 'Creation Date', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'action', label: 'Action', alignRight: false },
];

// ----------------------------------------------------------------------

export default function ClientReqTable({ requests, handleChangePage, page, projectId, onDelete }) {
  const [rowsPerPage] = useState(10);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === 'ar';
  const TABLE_HEAD = [
    { id: 'NAME_EN', label: t('General.name'), alignRight: isRtl && true },
    { id: 'creation_date', label: t('General.creationDate'), alignRight: isRtl && true },
    { id: 'status', label: t('General.Status'), alignRight: isRtl && true },
    { id: 'action', label: t('General.Action'), alignRight: isRtl && true },
  ];

  const rows = Array.isArray(requests)
    ? requests
    : requests?.content || requests?.data?.content || requests?.data || [];
  const totalElements = requests?.totalElements ?? requests?.data?.totalElements ?? rows.length;
  const totalPages = requests?.totalPages ?? requests?.data?.totalPages ?? (totalElements > 0 ? Math.ceil(totalElements / rowsPerPage) : 0);

  return (
    <>
      <Scrollbar>
        <TableContainer sx={{ minWidth: 800 }}>
          <Table sx={{ direction: isRtl ? 'rtl' : 'ltr' }}>
            <ClientReqHead t={t} isRtl={isRtl} headLabel={TABLE_HEAD} />
            <TableBody>
              {rows?.map((row) => {
                const { id, nameEn, nameAr, name, CREATION_DATE, creationDate, states, status, reservationStatus } = row || {};
                const displayName = isRtl ? (nameAr || name || nameEn) : (nameEn || name || nameAr);
                const rawDate = creationDate || CREATION_DATE || row?.createdAt;
                const displayDate = rawDate ? new Date(rawDate).toLocaleDateString() : '';
                const rawStatus = states || status || reservationStatus || '';
                const displayStatus =
                  rawStatus === 'ACTIVE'
                    ? t('General.ACTIVE') || t('General.Active') || 'نشط'
                    : rawStatus === 'IN_ACTIVE' || rawStatus === 'IN-ACTIVE'
                    ? t('General.IN_ACTIVE') || t('General.InActive') || 'غير نشط'
                    : rawStatus === 'RESTRICTED'
                    ? t('General.RESTRICTED') || 'مقيد'
                    : rawStatus === 'FREE' || rawStatus === 'AVAILABLE'
                    ? t('Units.available') || 'متاح'
                    : rawStatus === 'RESERVED' || rawStatus === 'TOTALLY_RESERVED'
                    ? t('Units.reserved') || 'محجوز'
                    : rawStatus === 'SOLD'
                    ? t('Units.sold') || 'مباع'
                    : rawStatus ? t(`General.${rawStatus}`) || rawStatus : '-';

                return (
                  <TableRow hover key={id} tabIndex={-1}>
                    <TableCell sx={{ textAlign: isRtl ? 'right' : 'left' }} component="th" scope="row">
                      <Typography
                        sx={{ color: 'text.secondary', fontWeight: '400', fontSize: '12px', lineHeight: '20px' }}
                        variant="subtitle2"
                        noWrap
                      >
                        {displayName || '-'}
                      </Typography>
                    </TableCell>

                    <TableCell sx={{ textAlign: isRtl ? 'right' : 'left' }} component="th" scope="row">
                      <Typography
                        sx={{ color: 'text.secondary', fontWeight: '400', fontSize: '12px', lineHeight: '20px' }}
                        variant="subtitle2"
                        noWrap
                      >
                        {displayDate || '-'}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ textAlign: isRtl ? 'right' : 'left' }} component="th" scope="row">
                      <Typography
                        sx={{ color: 'text.secondary', fontWeight: '400', fontSize: '12px', lineHeight: '20px' }}
                        variant="subtitle2"
                        noWrap
                      >
                        {displayStatus}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ textAlign: isRtl ? 'right' : 'left' }}>
                      <Button
                        onClick={() =>
                          navigate(id ? `/dashboard/units/edit/${id}` : '/dashboard/units/add', {
                            state: { from: 'edit-project', projectId: projectId || row?.projectId },
                          })
                        }
                      >
                        <EditIcon />
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Scrollbar>
      {rows.length === 0 && (
        <Box textAlign="center" py={4}>
          <Typography variant="subtitle1" color="text.secondary">
            {t('General.no_data') || 'No data found'}
          </Typography>
        </Box>
      )}

      {totalPages > 1 && (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '10px',
            marginTop: '2rem',
          }}
        >
          <Pagination count={totalPages} page={page + 1} onChange={handleChangePage} color="primary" />
          <Box sx={{ display: 'block' }}>
            {t('General.showing')} {page * rowsPerPage + 1} {t('General.to')}{' '}
            {Math.min((page + 1) * rowsPerPage, totalElements)} {t('General.of')} {totalElements}{' '}
            {t('General.entries')}
          </Box>
        </Box>
      )}
    </>
  );
}
